// 브랜드 템플릿 프리뷰 총 재생 시간 (초)
export const BRAND_TEMPLATE_PREVIEW_DURATION_SECONDS = 6;
